namespace Matrix.Rebalancer {
    export interface ModellingViewRow {
        ViewCode?: string;
        Name?: string;
        ModelTypeCode?: string;
        ColumnSetCode?: string;
        OwnershipBasisCode?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        ModelTypeName?: string;
        ModelTypeRowId?: number;
        ModelTypeLevels?: number;
        ColumnSetName?: string;
        ColumnSetRowId?: number;
        OwnershipBasisName?: string;
        OwnershipBasisRowId?: number;
    }

    export namespace ModellingViewRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'ViewCode';
        export const localTextPrefix = 'Rebalancer.ModellingView';
        export const deletePermission = 'DataAdmin:Rebalancer';
        export const insertPermission = 'DataAdmin:Rebalancer';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'DataAdmin:Rebalancer';

        export declare const enum Fields {
            ViewCode = "ViewCode",
            Name = "Name",
            ModelTypeCode = "ModelTypeCode",
            ColumnSetCode = "ColumnSetCode",
            OwnershipBasisCode = "OwnershipBasisCode",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            ModelTypeName = "ModelTypeName",
            ModelTypeRowId = "ModelTypeRowId",
            ModelTypeLevels = "ModelTypeLevels",
            ColumnSetName = "ColumnSetName",
            ColumnSetRowId = "ColumnSetRowId",
            OwnershipBasisName = "OwnershipBasisName",
            OwnershipBasisRowId = "OwnershipBasisRowId"
        }
    }
}
